import React from 'react'
import NavigationStep from './NavigationStep'
import useNavigationManager from '../hooks/use-navigation-manager'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'

function StepNavigation (props) {

  const manager = useNavigationManager()
  const port_manager = usePortManager()

  const items = []
  const step_validations = port_manager.getStepValidations()

  const isStepAccessible = function (index) {
    if (index < 1) return true
    for (let i = 0; i <= index; i++) {
      if (step_validations[i] !== true) {
        return false
      }
    }
    return true // Prev steps must be valid
  }

  manager.steps.map(function (key, index) {
    items.push(<NavigationStep key={index} step={index} accessible={isStepAccessible(index)}/>)
  })

  return (
    <nav id={'step-navigation'}>
      <ul className="step-navigation-list">
        {items}
      </ul>
    </nav>
  )
}

export default observer(StepNavigation)